import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

import moment from 'moment';

class FlightReportOfflineLegEditViewTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      id: null,
      staff_id: null,
      duty_id: null,
      flight_report_id: null,
      status_str: null,
      departure_location_id: null,
      arrival_location_id: null,
      leg_number: null,
      takeoff_scheduled: null,
      total_time_preview: null,
      engine_start_time: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: null,
      total_time: '00:00:00',
      navigation_time: '00:00:00',
      ifr_time: '00:00:00',
      night_time: '00:00:00',
      day_landings: 0,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: null,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: null,
      delay_departure: null,
      modal: false,
      locations_select: [],
      ptbr_codes_select: [],
      duties_select: [],
      staffs_select: [],
      flight_report_leg_edit: {},
      flight_report_leg_edit_staffs: {},
      style: {},
    };

    this.diffFlight = this.diffFlight.bind(this);
    this.diffTotalTime = this.diffTotalTime.bind(this);
    this.delayFlight = this.delayFlight.bind(this);
    this.delayTotalTime = this.delayTotalTime.bind(this);
    this.calcTimeFromMs = this.calcTimeFromMs.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    if (name === 'takeoff_time') {
      this.diffFlight(event.target.value, this.state.landing_time, change);
      this.delayFlight(event.target.value, this.state.takeoff_scheduled, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'landing_time') {
      this.diffFlight(this.state.takeoff_time, event.target.value, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
    } else if (name === 'engine_start_time') {
      this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'engine_shutoff_time') {
      this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'takeoff_scheduled') {
      this.delayFlight(this.state.takeoff_time, event.target.value, change);
    } else if (name === 'total_time_preview') {
      this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
    } else {
      this.setState(change);
    }
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {

    let takeoff_scheduled = newProps.flight_report_leg_edit.takeoff_scheduled_str; if (takeoff_scheduled === null) takeoff_scheduled = '';
    let total_time_preview = newProps.flight_report_leg_edit.total_time_preview; if (total_time_preview === null) total_time_preview = '';
    let engine_start_time = newProps.flight_report_leg_edit.engine_start_time_str; if (engine_start_time === null) engine_start_time = '';
    let takeoff_time = newProps.flight_report_leg_edit.takeoff_time_str; if (takeoff_time === null) takeoff_time = '';
    let landing_time = newProps.flight_report_leg_edit.landing_time_str; if (landing_time === null) landing_time = '';
    let engine_shutoff_time = newProps.flight_report_leg_edit.engine_shutoff_time_str; if (engine_shutoff_time === null) engine_shutoff_time = '';
    let takeoff_land_time = newProps.flight_report_leg_edit.takeoff_land_time; if (takeoff_land_time === null) takeoff_land_time = '';
    let total_time = newProps.flight_report_leg_edit.total_time; if (total_time === null) total_time = '';
    let navigation_time = newProps.flight_report_leg_edit.navigation_time; if (navigation_time === null) navigation_time = '';
    let ifr_time = newProps.flight_report_leg_edit.ifr_time; if (ifr_time === null) ifr_time = '';
    let night_time = newProps.flight_report_leg_edit.night_time; if (night_time === null) night_time = '';

    this.setState({
      locations_select: newProps.locations_select,
      ptbr_codes_select: newProps.ptbr_codes_select,
      style: newProps.style,
      date: newProps.date,
      id: newProps.flight_report_leg_edit.id,
      flight_report_id: newProps.flight_report_leg_edit.flight_report_id,
      status_str: newProps.flight_report_leg_edit.status_str,
      departure_location: newProps.flight_report_leg_edit.departure_location,
      arrival_location: newProps.flight_report_leg_edit.arrival_location,
      takeoff_scheduled: takeoff_scheduled,
      total_time_preview: total_time_preview,
      engine_start_time: engine_start_time,
      takeoff_time: takeoff_time,
      landing_time: landing_time,
      engine_shutoff_time: engine_shutoff_time,
      takeoff_land_time: takeoff_land_time,
      total_time: total_time,
      navigation_time: navigation_time,
      ifr_time: ifr_time,
      night_time: night_time,
      day_landings: newProps.flight_report_leg_edit.day_landings,
      night_landings: newProps.flight_report_leg_edit.night_landings,
      starts: newProps.flight_report_leg_edit.starts,
      pax: newProps.flight_report_leg_edit.pax,
      payload: newProps.flight_report_leg_edit.payload,
      external_load_long_line: newProps.flight_report_leg_edit.external_load_long_line,
      external_load_short_line: newProps.flight_report_leg_edit.external_load_short_line,
      fuel_start: newProps.flight_report_leg_edit.fuel_start,
      fuel_end: newProps.flight_report_leg_edit.fuel_end,
      ptbr_code: newProps.flight_report_leg_edit.ptbr_code,
      delay_departure: newProps.flight_report_leg_edit.delay_departure,
      delay_time: newProps.flight_report_leg_edit.delay_time,
      leg_number: newProps.flight_report_leg_edit.leg_number,
      start_parameter_total: newProps.start_parameter_total,
      xml: newProps.xml,
      external_load: newProps.external_load,
    });
  }


    diffFlight(takeoff_time, landing_time, change) {
      if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        landing_time = this.state.date + ' ' + landing_time;

        takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        landing_time = moment(landing_time, "DD/MM/YYYY HH:mm:ss");

        if (takeoff_time > landing_time) {
          landing_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
        landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
        let diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());
        if (landing_time > takeoff_time) {
          change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
          change['navigation_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['takeoff_land_time'] = '00:00';
          change['navigation_time'] = '00:00';
        }
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
      this.delayTotalTime(this.state.total_time_preview, change['takeoff_land_time'], change);
    }

    diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
      let start = null;
      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      } else if (start_parameter_total !== null) {
        start = start_parameter_total.substring(11);
      }

      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      }

      let finish = null;
      if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
        finish = landing_time;
      }
      if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
        finish = engine_shutoff_time;
      }

      if(start && finish) {
        start = this.state.date + ' ' + start;
        finish = this.state.date + ' ' + finish;

        start = moment(start, "DD/MM/YYYY HH:mm:ss");
        finish = moment(finish, "DD/MM/YYYY HH:mm:ss");

        if (start > finish) {
          finish.add(1, 'd');
        }

        start = new Date(start.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
        finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));

        let diffTime = Math.abs(finish.getTime() - start.getTime());
        if (finish > start) {
          change['total_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['total_time'] = '00:00';
        }

        this.setState(change);
      } else {
        change['total_time'] = '00:00';
        this.setState(change);
      }
    }

    delayFlight(takeoff_time, takeoff_scheduled, change) {
      if(takeoff_scheduled) {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        takeoff_scheduled = this.state.date + ' ' + takeoff_scheduled;

        takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        takeoff_scheduled = moment(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");

        let diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');

        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
          takeoff_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
        takeoff_scheduled = new Date(takeoff_scheduled.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
        let diffTime = Math.abs(takeoff_time.getTime() - takeoff_scheduled.getTime());
        if (takeoff_time > takeoff_scheduled) {
          change['delay_departure'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_departure'] = '00:00';
        }
      } else {
        change['delay_departure'] = '00:00';
      }
      this.setState(change);
    }

    delayTotalTime(total_time_preview, takeoff_land_time, change) {
      if(takeoff_land_time) {
        takeoff_land_time = moment().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
        total_time_preview = moment().format("YYYY-MM-DD") + ' ' + total_time_preview;

        takeoff_land_time = new Date(takeoff_land_time.replace(/ /g,"T"));
        total_time_preview = new Date(total_time_preview.replace(/ /g,"T"));
        let diffTime = Math.abs(takeoff_land_time.getTime() - total_time_preview.getTime());
        if (takeoff_land_time > total_time_preview) {
          change['delay_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_time'] = '00:00';
        }
      }
      this.setState(change);
    }

    calcTimeFromMs(diffTime) {
      diffTime = diffTime/1000;
      var secs = diffTime % 60;
      diffTime = (diffTime - secs) / 60;
      var mins = diffTime % 60;
      var hrs = (diffTime - mins) / 60;
      if (secs < 10) { secs = '0' + secs; }
      if (mins < 10) { mins = '0' + mins; }
      if (hrs < 10) { hrs = '0' + hrs; }
      return hrs + ':' + mins + ':' + secs ;
    }


  render() {
    var self = this;
    return (
  <tr>
    <td>{this.state.flight_report_id}</td>
    <td>
      <RequestApi ref={'request_api'} />
      {this.state.departure_location}
    </td>
    <td>
      {this.state.arrival_location}
    </td>
    <td>
      {this.state.engine_start_time}
    </td>
    <td>
    </td>
    <td>
      {this.state.takeoff_time}
    </td>
    <td>
    </td>
    <td>
      {this.state.landing_time}
    </td>
    <td>
    </td>
    <td>
      {this.state.engine_shutoff_time}
    </td>
    <td>
    </td>
    <td>
      {this.state.takeoff_land_time}
    </td>
    <td>
      {this.state.total_time}
    </td>
    <td>
      {this.state.navigation_time}
    </td>
    <td>
      {this.state.ifr_time}
    </td>
    <td>
      {this.state.night_time}
    </td>
    <td>
      {this.state.day_landings}
    </td>
    <td>
      {this.state.night_landings}
    </td>
    <td>
      {this.state.starts}
    </td>
    <td>
      {this.state.pax}
    </td>
    <td>
      {this.state.payload}
    </td>
    {this.state.external_load == 1 ? 
      <td>
        {this.state.external_load_long_line}
      </td>

    : ''
    }
    {this.state.external_load == 1 ? 
      <td>
          {this.state.external_load_short_line}
      </td>
    : ''
    }
    <td>
        {this.state.fuel_start}
    </td>
    <td>
        {this.state.fuel_end}
    </td>
    {this.state.xml == 1 ? 
      <td>
          {this.state.ptbr_code}
      </td>
    : ''
    }
    <td>{this.state.status_str}</td>
    <td style={{width: '200px', whiteSpace: 'nowrap', textAlign: 'center'}}>
      <button type="button" className="btn btn-success" onClick={() => {self.props.updateLegData(this.state.flight_report_id, this.state.id)}}><i className="fa fa-fw fa-plus"></i></button>
    </td>

  </tr>
    );
  }
}

export default FlightReportOfflineLegEditViewTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportOfflineLegEditViewTab.js